var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16a8 8 0 118-8 8.009 8.009 0 01-8 8zM8 1.085A6.915 6.915 0 1014.915 8 6.923 6.923 0 008 1.085z",
    fill: "#879494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.116 5.352l-4.752 4.752a.794.794 0 001.123 1.123l4.752-4.752a.794.794 0 00-1.123-1.123z",
    fill: "#879494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.761 8.637l2.59 2.59a.794.794 0 001.124-1.123l-2.59-2.59a.794.794 0 00-1.123 1.123z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/checkCircleIcon.0cce40d5.svg";
export { MemoForwardRef as ReactComponent };